<template>
  <div :class="[$style.contactFormStickyCTA, isHidden ? $style.isHidden : '']">
    <HgButton theme="primary" :icon="showIcon ? 'Email' : undefined" @click="emit('click', $event)">
      {{ t(buttonText) }}
    </HgButton>
  </div>
</template>

<script lang="ts" setup>
import { HgButton } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'ContactFormStickyCTA',
});

interface Props {
  isHidden: boolean;
  showIcon: boolean;
  buttonText: string;
}
withDefaults(defineProps<Props>(), {
  isHidden: false,
  showIcon: true,
  buttonText: 'contactForm.CONTACT_ADVERTISER',
});

const emit = defineEmits<{
  click: [event: unknown];
}>();
</script>

<style lang="scss" module>
@import '@/assets/variables';

$sticky-cta-height: 68px;
$sticky-cta-shadow: 0 0 $space-75 0 rgba($color-grey-120, 0.3);
$sticky-cta-spacing: $space-75;

.contactFormStickyCTA {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 11;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: $sticky-cta-height;
  padding: $sticky-cta-spacing;
  background-color: $color-white;
  box-shadow: $sticky-cta-shadow;
  transition:
    bottom $transition-duration $transition-easing,
    left $transition-duration $transition-easing;

  button {
    min-width: 100%;

    &:focus {
      outline: none;
    }
  }

  &.isHidden {
    bottom: -$sticky-cta-height;
  }
}
</style>
